/* eslint-disable react/no-multi-comp */
import './Routes.scss';
import React from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ErrorsPage from '../modules/ErrorsExamples/ErrorsPage';
import UserProfile from '../components/UserProfile';
import Loans from '../pages/LoansPage.js';
import useTheme from '../hooks/useTheme';
import Login from '../pages/LoginPage';
import Logout from '../pages/LogoutPage';
import '../../_metronic/_assets/sass/pages/login/login-3.scss';
import ChangePassword from '../pages/ChangePasswordPage';

export function Routes () {
    return (
        <Switch>
            <Redirect exact from='/' to='/dashboard' />
            <Redirect exact from='/auth' to='/auth/login' />
            <Route path="/error" component={ErrorsPage}/>
            <Route path="/logout" component={Logout}/>
            <Route path="/auth/login">
                <LayoutAuth>
                    <Login />
                </LayoutAuth>
            </Route>
            <Route path="/auth/change-password">
                <LayoutAuth>
                    <ChangePassword />
                </LayoutAuth>
            </Route>
            <RouteAuthed path='/dashboard'>
                <LayoutMain>
                    <Loans />
                </LayoutMain>
            </RouteAuthed>
        </Switch>
    );
};

function RouteAuthed ({ path, children }) {
    const { isAuthed } = useSelector((store) => ({ isAuthed: !!store.auth.user }));
    return (
        <Route path={path}>
            {isAuthed
                ? (children)
                : (<Redirect to="/logout"/>)
            }
        </Route>
    );
}

function LayoutMain ({ children }) {
    const theme = useTheme();
    return (
        <div className='layout'>
            <header className='layout-header'>
                <img className='layout-header-logo' src={`/${theme.name}/logo-dark.png`} alt="logo" width="100" />
                <UserProfile showAvatar={false} showHi={true} showBadge={false} />
            </header>
            <div className="layout-content">
                {children}
            </div>
        </div>
    );
}

function LayoutAuth ({ children }) {
    const theme = useTheme();
    return (
        <div className="layout-auth">
            <header className='layout-auth-header'>
                <img alt="Logo" src={`/${theme.name}/logo-dark.png`} width="275" />
                <p className="text-center">
                    ¡Bienvenido a {theme.label}!
                </p>
            </header>
            <div className='layout-auth-content'>
                {children}
            </div>
        </div>
    );
}
